<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.gspl" alt style="white-space:normal;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:14pt;font-family:Arial;">
              High speed spinner
              block
            </span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:10pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:10pt;font-family:Arial;">
          This unit is used for spinning copper pipe, with high production
          efficiency, good quality, and high yield. The production of our company has
          been sold to Ukraine etc.
        </span>
      </p>
      <p>
        <br>
      </p>
      <p></p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td colspan="8" style="border:solid windowtext 1.0pt;" valign="top" width="568">
              <p style="text-align:center;" align="center">
                <span style="font-size:14pt;font-family:Arial;">
                  Technical
                  parameters
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">No.</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Model
                  &amp; Data
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Units</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ2130</span>
                <span style="font-size:10pt;font-family:Arial;color:#333333;">－</span>
                <span style="font-size:10pt;font-family:Arial;">Φ2200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1800</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ800</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  Vertical block
                  for capillary
                </span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">1</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">diameter of drum</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ2130</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1800</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ800</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ500</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">2</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">working length of the drum</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">400</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">350</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">350</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">350</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">70</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">3</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">max. dimension of shell</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ52×2.5</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ38×1.8</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ25×1.5</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ12×1</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ8×1.2</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">min dimension of the product</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">mm</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ4×0.35</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ4×0.35</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ3×0. 5</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ3×0. 5</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">Φ1.5×0. 5</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">max. coil weight</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">kg</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">550-1000</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">400</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">300</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">100</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">6</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">max. drawing force</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">kg</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">10000</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">6000</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">4000</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">2000</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">850</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">7</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">drawing speed</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">m/min</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;line-height:150%;font-family:Arial;">0-150-800</span>
              </p>
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-1200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-400</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-400</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-400</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0-70</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">8</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">number of baskets for circulation</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">pcs</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">8</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">-</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">3</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">-</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">9</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">total installed power</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">kw</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">380-440</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">200</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">110</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">55</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">A.C11</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">10</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">consumption of compressed air</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">m</span>
                <span style="font-size:10pt;font-family:Arial;">³/min</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0.8</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0.6</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0.6</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">0.6</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">-</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="31">
              <p>
                <span style="font-size:10pt;font-family:Arial;">11</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="116">
              <p>
                <span style="font-size:10pt;font-family:Arial;">
                  electric
                  control system
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="53">
              <p>
                <span style="font-size:10pt;font-family:Arial;">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="106">
              <p>
                <span style="font-size:10.0pt;font-family:&quot;color:black;">
                  <span style="font-family:Arial;">digital</span>
                  <span style="font-family:Arial;">&nbsp;</span>
                  <span style="font-family:Arial;">
                    system dialogue between
                    person and machine
                  </span>
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="58">
              <p>
                <span style="font-size:10pt;font-family:Arial;">digital system</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="62">
              <p>
                <span style="font-size:10pt;font-family:Arial;">digital system</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="60">
              <p>
                <span style="font-size:10pt;font-family:Arial;">digital system</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="81">
              <p>
                <span style="font-size:10pt;font-family:Arial;">AC frequency converting</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        gspl: require("../../../assets/img/common/gspl.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/gspl.vue